/*
 *For Image Lazy Loading
 */
import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import DownloadModal from "./DownloadModal";

const relatedPics = [
  {
    title: "monitor",
  },
  {
    title: "men",
  },
  {
    title: "robot",
  },
  {
    title: "tablet",
  },
  {
    title: "monitor",
  },
];

function ImageGallery({ pics, title, length }) {
  /*
   *Show/hide Download able modal
   */
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  /*
   *Hold is image is selected or not
   */
  const [isImageSelected, setIsImageSelected] = useState(false);

  /*
   *Hold Selected Image
   */
  const [selectedImage, setSelectedImage] = useState();
  /*
   *Select Image to preview
   */
  const imageSelectorHandler = (e) => {
    setIsImageSelected(true);
    setSelectedImage(e);
  };

  return (
    <div>
      <div className={`${isImageSelected && "flex flex-col md:flex-row"}`}>
        <div
          className={`${
            isImageSelected && "max-h-[509px] w-full  max-w-[890px]"
          }`}
        >
          <div className="flex flex-col  mb-5 items-start">
            <div className="flex  items-center">
              <h1 className="text-lg	font-semibold">{title}</h1>
              <p className="font-normal flex items-center ml-6	text-sm	text-[#747474]">
                <img src="/dot.svg" className="mr-1.5 ml-7" alt="dot" />
                {length} images
              </p>
            </div>
          </div>
          {isImageSelected ? (
            /*
             *Selected Image full preview
             */
            // <div className=" block h-[507px]   w-[809px]">
            <div className="relative h-full w-full">
              <LazyLoadImage
                height="100%"
                effect="blur"
                width="100%"
                className="h-full w-full"
                src={`/${selectedImage}.png`}
                alt={selectedImage}
              />
              <img
                onClick={() => {
                  setShowDownloadModal(true);
                }}
                className="absolute bottom-16 right-11 p-3 rounded-full cursor-pointer bg-[#000]"
                src="/download-btn.svg"
                alt="download-btn"
              />
            </div>
          ) : (
            // </div>
            /*
             *Full image gallery
             */
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2.5	 mb-5">
              {pics.map((pic, index) => (
                <LazyLoadImage
                  key={index + 1}
                  alt={pic.title}
                  height={pic.height}
                  effect="blur"
                  src={`${pic.title}.png`}
                  width={pic.width}
                  className="w-full cursor-pointer"
                  onClick={() => imageSelectorHandler(pic.title)}
                />
              ))}
            </div>
          )}
        </div>
        {/*
         *Related Image's for Selected Image
         */}
        {isImageSelected && (
          <div className="flex flex-col  mt-12 md:mt-0 md:ml-12">
            <div className="flex mb-5 justify-center md:justify-start items-center">
              <h1 className="text-lg	font-semibold">
                Similar to “Colorful Cosmos”
              </h1>
              <p className="font-normal flex items-center ml-6	text-sm	text-[#747474]">
                <img src="/dot.svg" className="mr-1.5 ml-7" alt="dot" />
                {length} images
              </p>
            </div>
            <div className="grid grid-cols-2 gap-2.5">
              {relatedPics.map((pic, index) => (
                <div
                  key={index + 1}
                  className="md:max-h-[162px]	 md:max-w-[220px]"
                >
                  <LazyLoadImage
                    alt={pic.title}
                    height="100%"
                    effect="blur"
                    src={`${pic.title}.png`}
                    width="100%"
                    className="w-full h-full cursor-pointer"
                    onClick={() => imageSelectorHandler(pic.title)}
                  />
                </div>
              ))}
              <div className="md:max-h-[162px]  md:max-w-[219px] relative">
                <LazyLoadImage
                  alt="robot"
                  height="100%"
                  effect="blur"
                  src={`robot.png`}
                  width="100%"
                  className="w-full h-full cursor-pointer"
                />
                <p className="absolute top-0 h-full w-full flex items-center justify-center text-white font-semibold text-lg cursor-pointer bg-[rgba(0, 0, 0, 0.38)]">
                  See More
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
      {showDownloadModal && (
        <div className="h-full fixed top-[236px] flex items-start justify-center w-full right-0 left-0 ">
          <DownloadModal
            setShowModal={setShowDownloadModal}
            imgSrc={selectedImage}
          />
        </div>
      )}
    </div>
  );
}

export default ImageGallery;
